import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Assortiment from "../components/assortiment/Assortiment";

export default function AssortimentView() {
  return (
    <div className="pageWrapper">
      <Header title="Bestellen" needsLocation="Yes" showSearch={true} />
      <div className="contentWrapper fadeInDelayed">
        <Assortiment />
      </div>
      <BottomNavBar />
    </div>
  );
}
